// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1NBk6","label":"Completed_label__1OQr6"};